package songwritersnotebook.app.tutorial

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.navigation.NavController
import songwritersnotebook.app.navigation.AppRoutes

@Composable
fun TutorialNavigator(navController: NavController) {
    val currentTutorialStep by TutorialManager.currentStep.collectAsState()
    LaunchedEffect(currentTutorialStep) {
        if (currentTutorialStep == TutorialStep.NONE || currentTutorialStep == TutorialStep.FINISH) return@LaunchedEffect

        val currentRoute = navController.currentDestination?.route
        
        val homeSteps = setOf(
            TutorialStep.WELCOME, TutorialStep.HOME_SETTINGS_BUTTON, TutorialStep.HOME_SEARCH,
            TutorialStep.HOME_CREATE_SONG, TutorialStep.HOME_SONG_CONTEXT, TutorialStep.HOME_SHARED_TAB,
            TutorialStep.HOME_SONG_CARD, TutorialStep.HOME_TAP_SONG
        )
        val settingsSteps = setOf(
            TutorialStep.SETTINGS_GENERAL, TutorialStep.SETTINGS_ACCOUNT, TutorialStep.SETTINGS_BACK
        )
        val editorSteps = setOf(
            TutorialStep.EDITOR_INTRO, TutorialStep.EDITOR_ADD_SECTION, TutorialStep.EDITOR_WORD_FINDER_OPEN,
            TutorialStep.EDITOR_WORD_FINDER_SEARCH, TutorialStep.EDITOR_CHORD_LIBRARY_OPEN,
            TutorialStep.EDITOR_CHORD_LIBRARY_SELECT, TutorialStep.EDITOR_OPEN_CREATOR_EXPLAIN,
            TutorialStep.EDITOR_CREATE_CHORD_VOICING, TutorialStep.EDITOR_CREATE_CHORD_SHUFFLE,
            TutorialStep.EDITOR_CREATE_CHORD_CUSTOM_TOGGLE, TutorialStep.EDITOR_CREATE_CHORD_CUSTOM_EXPLAIN,
            TutorialStep.EDITOR_CREATE_CHORD_TUNING, TutorialStep.EDITOR_CREATE_CHORD_FAVORITE,
            TutorialStep.EDITOR_CREATE_CHORD_SAVE, TutorialStep.EDITOR_AI_OPEN, TutorialStep.EDITOR_AI_HARMONY,
            TutorialStep.EDITOR_CONTEXT_MENU_OPEN, TutorialStep.EDITOR_CONTEXT_MENU_MOVE, 
            TutorialStep.EDITOR_CONTEXT_MENU_DUPLICATE_DELETE, TutorialStep.EDITOR_CONTEXT_MENU_CHORDS, 
            TutorialStep.EDITOR_CONTEXT_MENU_ADD, TutorialStep.EDITOR_SETTINGS_OPEN, TutorialStep.EDITOR_STUDIO_OPEN
        )
        val studioSteps = setOf(
            TutorialStep.STUDIO_INTRO, TutorialStep.STUDIO_SETTINGS, TutorialStep.STUDIO_TABS,
            TutorialStep.STUDIO_LENGTH, TutorialStep.STUDIO_INTERVAL, TutorialStep.STUDIO_DRAG,
            TutorialStep.STUDIO_TRACK_SETTINGS, TutorialStep.STUDIO_TRACK_MINIMIZE, TutorialStep.STUDIO_CONTEXT_MENU
        )

        when {
            currentTutorialStep in homeSteps && currentRoute != AppRoutes.HOME_SCREEN -> {
                navController.navigate(AppRoutes.HOME_SCREEN) {
                    popUpTo(AppRoutes.AUTH_SCREEN) { inclusive = false }
                }
            }
            currentTutorialStep in settingsSteps && currentRoute != AppRoutes.SETTINGS_SCREEN -> {
                navController.navigate(AppRoutes.SETTINGS_SCREEN)
            }
            currentTutorialStep in editorSteps && currentRoute?.startsWith(AppRoutes.EDITOR_SCREEN) != true -> {
                navController.navigate("${AppRoutes.EDITOR_SCREEN}/${TutorialManager.TUTORIAL_SONG_ID}")
            }
            currentTutorialStep in studioSteps && currentRoute?.startsWith(AppRoutes.STUDIO_SCREEN) != true -> {
                navController.navigate("${AppRoutes.STUDIO_SCREEN}/${TutorialManager.TUTORIAL_SONG_ID}")
            }
        }
    }
}
